<div class="flex flex-col gap-8">
  <!-- Card skeleton -->
  <div class="flex flex-col gap-6 lg:gap-8">
    <!-- Section 1: Public Profile -->
    <div class="flex flex-col gap-5">
      <div class="flex flex-col gap-1">
        <div class="h-8 w-48 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
        <div class="h-4 w-72 rounded overflow-hidden mt-1"><dss-libs-ui-skeleton /></div>
      </div>
      <!-- Avatar row -->
      <div class="flex flex-col gap-3">
        <div class="h-5 w-25 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
        <div class="flex items-center gap-4">
          <div class="w-20 h-20 rounded-full overflow-hidden shrink-0"><dss-libs-ui-skeleton /></div>
          <div class="flex flex-col gap-2">
            <div class="h-9 w-36 rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
            <div class="h-3.5 w-52 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          </div>
        </div>
      </div>
      <!-- Input row 1 -->
      <div class="flex flex-col lg:flex-row gap-5 lg:gap-6">
        <div class="flex flex-col gap-2 w-full">
          <div class="h-5 w-24 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          <div class="h-12 w-full rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
        </div>
        <div class="flex flex-col gap-2 w-full">
          <div class="h-5 w-24 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          <div class="h-12 w-full rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
        </div>
      </div>
      <!-- Input row 2 -->
      <div class="flex flex-col lg:flex-row gap-5 lg:gap-6">
        <div class="flex flex-col gap-2 w-full">
          <div class="h-5 w-24 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          <div class="h-12 w-full rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
        </div>
        <div class="flex flex-col gap-2 w-full">
          <div class="h-5 w-24 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          <div class="h-12 w-full rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
        </div>
      </div>
    </div>
    <hr class="border-0 border-t border-stroke-soft" />
    <!-- Section 2: Preferences -->
    <div class="flex flex-col gap-5">
      <div class="flex flex-col gap-1">
        <div class="h-6 w-32 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
        <div class="h-5 w-64 rounded overflow-hidden mt-1"><dss-libs-ui-skeleton /></div>
      </div>
      <div class="flex flex-col lg:flex-row gap-5 lg:gap-6">
        <div class="flex flex-col gap-2 w-full lg:w-1/2">
          <div class="h-4 w-36 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
          <div class="h-12 w-full rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
        </div>
        <div class="w-full lg:w-1/2"></div>
      </div>
    </div>
    <hr class="border-0 border-t border-stroke-soft" />
    <!-- Section 3: Security -->
    <div class="flex flex-col gap-5">
      <div class="flex flex-col gap-1">
        <div class="h-6 w-36 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
        <div class="h-5 w-56 rounded overflow-hidden mt-1"><dss-libs-ui-skeleton /></div>
      </div>
      <div class="h-9 w-36 rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
    </div>
  </div>
  <!-- Actions row -->
  <div class="flex flex-col-reverse gap-3 lg:flex-row lg:justify-end lg:gap-4">
    <div class="h-11 w-full lg:w-32 rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
    <div class="h-11 w-full lg:w-32 rounded-lg overflow-hidden"><dss-libs-ui-skeleton /></div>
  </div>
</div>
